import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { StoresState } from '../models/invoices.models';

export const GetStores = createAction('[Customer data: Invoices]: Get Stores');

export const PanelStatusChanged = createAction('[Customer data: Invoices]: Panel Status Changed');

export const GetStoresSuccess = createAction(
  '[Customer data: Invoices]: Get Stores Success',
  props<{ res: StoresState[] }>(),
);

export const GetStoresFailed = createAction(
  '[Customer data: Invoices]: Get Stores Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const InvoiceNumberChanged = createAction(
  '[Customer data: Invoices]: Invoice Number Changed',
  props<{ invoiceNumber: string }>(),
);

export const LoyaltyCardChanged = createAction(
  '[Customer data: Invoices]: Loyalty Card Changed',
  props<{ loyaltyCard: string }>(),
);

export const DateFromChanged = createAction(
  '[Customer data: Invoices]: Date From Changed',
  props<{ dateFrom: Date; dateFromFormat: string }>(),
);

export const DateUntilChanged = createAction(
  '[Customer data: Invoices]: Date Until Changed',
  props<{ dateUntil: Date; dateUntilFormat: string }>(),
);

export const ClearDateFrom = createAction('[Customer data: Invoices]: Clear Date From');

export const ClearDateUntil = createAction('[Customer data: Invoices]: Clear Date Until');

export const StoreChanged = createAction(
  '[Customer data: Invoices]: Store Changed',
  props<{ store: string }>(),
);

export const ClearFilters = createAction('[Customer data: Invoices]: Clear Filters');

export const InvoiceModal = createAction('[Customer data: Invoices]: Open Invoice Modal');
